import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { PhaseType } from 'modules/ats/lib/enums'
import { type CandidateSources, getSourceLabel } from 'modules/ats/lib/utils/candidateSources'

export interface Cv {
  file: string
  content_type: string
  filename: string
  size: number
  created_at: string
}

export type DisqualifiedReason =
  | 'not_a_fit'
  | 'underqualified'
  | 'salary'
  | 'no_response'
  | 'offer_not_accepted'
  | 'self_disqualified'
  | 'other_offer'
  | 'other_reason'

interface CustomValue {
  id: string
  label: string
  value: string
  field_id: string
  required: boolean
  installed: boolean
  instance_id: string
  type: 'long_text'
}

export interface IApplication {
  id: string
  company_id?: string | null
  ats_job_posting_id: string
  ats_job_posting_title: string
  ats_candidate_id: string
  ats_application_phase_id: string
  ats_application_phase_name: string
  ats_application_phase_type: PhaseType
  employee_id?: string
  first_name: string
  last_name: string
  full_name: string
  email: string
  phone: string
  talent_pool: boolean
  qualified: boolean
  disqualified_reason?: DisqualifiedReason
  created_at: string
  photo?: string
  photo_thumbnail?: string
  cover_letter?: string
  custom_values: CustomValue[]
  cv?: Cv
  ats_conversation_id?: string
  source: `${CandidateSources}`
  medium: string | null
  rating_average?: number | null
}

class Application extends Model<IApplication> {
  constructor(attr: IApplication) {
    super(attr)
    makeObservable(this, {
      cv: computed,
      utmInfo: computed,
    })
  }

  static urlRoot() {
    return '/ats/applications'
  }

  get cv(): Cv | null | undefined {
    return this.toJS().cv
  }

  get utmInfo(): string {
    const utm_medium = this.get('medium') || ''
    if (utm_medium) return utm_medium

    return getSourceLabel(this.attributes.source)
  }

  get source(): string {
    return getSourceLabel(this.attributes.source)
  }
}

export default Application
